import { Color } from 'csstype'
import { Fragment } from 'react'
import { CidadaoListagemDiabetesQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

import { AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection } from '../AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection'
import { AcompanhamentoCondicaoSaudeAcompanhamentoDiabetesSection } from './AcompanhamentoCondicaoSaudeAcompanhamentoDiabetesSection'
import { AcompanhamentoCondicaoSaudeExamesAccordionSection } from './AcompanhamentoCondicaoSaudeExamesAccordionSection'

interface AcompanhamentoCondicaoSaudeDiabetesAccordionPanelProps {
  row: Readonly<CidadaoListagemDiabetesQueryModel>
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeDiabetesAccordionPanel({
  row,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeDiabetesAccordionPanelProps>) {
  return (
    <Fragment>
      <AcompanhamentoCondicaoSaudeAcompanhamentoDiabetesSection
        dataUltimaConsulta={row?.diabetes?.dataUltimaConsulta}
        qtdConsultas={row?.diabetes?.qtdConsultas}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeExamesAccordionSection
        valorExameHemoglobinaGlicada={row?.diabetes?.valorExameHemoglobinaGlicada}
        dataExameHemoglobinaGlicada={row?.diabetes?.dataExameHemoglobinaGlicada}
        dataSolicitacaoHemoglobinaGlicada={row?.diabetes?.dataSolicitacaoHemoglobinaGlicada}
        dataAvaliacaoPes={row?.diabetes?.dataAvaliacaoPes}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection
        dataUltimasVisitasDomiciliares={row?.diabetes?.visitasDomiciliaresReportDto?.dataUltimasVisitasDomiciliares}
        qtdVisitasDomiciliares={row?.diabetes?.visitasDomiciliaresReportDto?.qtdVisitasDomiciliares}
        iconColor={iconColor}
      />
    </Fragment>
  )
}
